import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { LocaleService } from '@app/system/services/locale.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PopupComponent } from '@app/components/popup/popup.component';
import { BeadComponent } from '../../knowledge-bead/bead/bead.component';
import { BaseService } from '@app/system/services/base.service';
import { DetectDeviceService } from '@app/system/services/detect-device.service';
import { ContentImageCard } from '@app/components/widget/content-image-card/content-image-card.component';
import { ApiService } from '@app/modules/resource/utilities/services/api.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';

@Component({
	selector: 'app-detail',
	templateUrl: './detail.component.html',
	styleUrls: ['./detail.component.scss']
})
export class DetailComponent implements OnInit, OnChanges {

	@Input() resourceDetail;
	@Input() status;

	currentUser;
	beadsData: Array<ContentImageCard> = [];
	loader = false;
	beadLoaded = false;

	constructor(
		public locale: LocaleService,
		public gfService: GlobalFunctionService,
		private popup: MatDialog,
		private baseService: BaseService,
		public detectDevice: DetectDeviceService,
		private resourceApiService: ApiService
	) {
		this.currentUser = this.gfService.sessionUser;
	}

	ngOnInit(): void {
		this.getBeadList();
	}

	ngOnChanges(changes) {
		if (
			changes.status &&
			changes.status.currentValue &&
			this.resourceDetail) {
			if (this.beadsData.length && this.resourceDetail.createdBy !== this.currentUser.userID) {
				if (['assigned', 'reassigned', 'overdue'].includes(changes.status.currentValue.key)) {
					for (const data of this.beadsData) {
						data.removable = true;
					}
				} else {
					for (const data of this.beadsData) {
						data.removable = false;
					}
				}
			}
		}
	}

	searchPeopleDetail(data) {
		if (data && data.createdBy) {
			this.baseService.userDetail(data.createdBy);
		}
	}

	getBeadList() {
		this.loader = true;
		const apiData: any = {
			resRef: this.resourceDetail.resourceID,
			languageCode: 'en'
		};

		const resourceTypeStatus = this.baseService.resourceType;
		for (const status of resourceTypeStatus) {
			if (status.key === 'knowledgeBead') {
				apiData.resourceTypeID = status.value;
			}
		}
		// if (['assigned', 'overdue'].includes(this.status.key)) {
		// 	apiData.status = 1;
		// } else if (this.status.key === 'reassigned') {
		// 	apiData.status = 1;
		// } else if (this.status.key === 'submitted') {
		// 	apiData.status = 3;
		// } else if (this.status.key === 'closed') {
		// 	apiData.status = 2;
		// }
		const headers = {};
		this.beadLoaded = true;
		this.resourceApiService.getResourceList(apiData, headers).subscribe(
			(response) => {
				if (response && response.records.length) {
					this.dataBuild(response.records);
				}
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => {
				this.loader = false;
			});
	}

	dataBuild(record) {
		for (const data of record) {
			if (data.resourceFormat) {
				data.resourceFormat = this.baseService.referenceType('resourceFormat', data.resourceFormat);
				data.beadStatus = data.status;
				// data.status = data.resourceFormat.caption;
				delete data.status;
				delete data.description;
				const cardData: ContentImageCard = {
					thumbnail: '',
					removable: false,
					title: data.title,
					date: this.gfService.dateFormat(data.createdAt, 'MMM d y'),
					status: null
				};
				if (data.resourceFormat) {
					cardData.type = data.resourceFormat.caption;
					cardData.format = data.resourceFormat.key;
				}
				if (data.profilePicURL) {
					cardData.userThumbnail = data.profilePicURL;
				}

				if (data.authors && data.authors.length) {
					cardData.userThumbnail = data.authors[0].profilePicURL || '';
					cardData.creator = `${data.authors[0].firstName}${data.authors[0].lastName
						? ' ' + data.authors[0].lastName
						: ''}`;
					if (data.authors.length > 1) {
						cardData.creator = `${cardData.creator} + ${data.authors.length - 1}`;
					}
				}

				if (data.resource) {
					if (data.resource.hasOwnProperty('duration')) {
						cardData.duration = data.resource.duration;
					}
					if (data.resource.thumbnail) {
						cardData.thumbnail = data.resource.thumbnail;
					}
				}

				if (cardData.thumbnail === '' && data.resourceFormat) {
					cardData.thumbnail = data.resourceFormat.image;
				}
				this.beadsData.push(this.gfService.JSONMerge(cardData, data));
			}
			if (this.status && this.resourceDetail) {
				if (this.resourceDetail.resourceAction.deleteBead &&
					['assigned', 'reassigned', 'overdue'].includes(this.status.key)) {
					for (const data of this.beadsData) {
						data.removable = true;
					}
				}
			}
		}
	}

	addBead(event?) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: BeadComponent,
				componentData: [
					{
						variableName: 'resourceID',
						value: this.resourceDetail.resourceID
					}
				],
				triggerEl: event
			},
			disableClose: true,
			maxWidth: '860px',
			autoFocus: false
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
				if (result.dialogRef) {
					result.dialogRef['_afterClosed'].subscribe(data => {
						if (data) {
							this.dataAlter(data);
						}
					});
				} else {
					this.dataAlter(result);
				}
			}
		});
	}

	dataAlter(result) {

		let title = '';
		let thumbnail = '';
		let format = result.type;
		if (result.type === 'embed') {
			title = result.data.embed.title;
			if (result.data.embed.image) {
				thumbnail = result.data.embed.image;
			} else {
				thumbnail = this.baseService.resourceFormat.find(items => items.key === 'link').image;
			}
			format = 'link';
		} else if (result.type === 'video') {
			title = result.data.title;
			thumbnail = result.data.video.thumbnailSrc;
		} else if (result.type === 'audio') {
			title = result.data.title;
			thumbnail = result.data.audio.thumbnailSrc;
		} else if (result.type === 'document') {
			title = result.data.title;
			thumbnail = this.baseService.resourceFormat.find(items => items.key === 'document').image;
		} else if (result.type === 'page') {
			title = result.data.title;
			thumbnail = this.baseService.resourceFormat.find(items => items.key === 'page').image;
		}
		// console.log(result);
		const status = this.baseService.referenceType('resourceFormat', result.resourceFormat).caption;
		this.beadsData.unshift(
			this.gfService.JSONMerge({
				title,
				thumbnail,
				format,
				status: null,
				type: status,
				date: this.gfService.dateFormat(Date.now(), 'MMM d y'),
				removable: true,
				creator: `${this.currentUser.profile.firstName}${this.currentUser.profile.lastName
					? ' ' + this.currentUser.profile.lastName
					: ''}`,
				userThumbnail: this.currentUser.profile.profilePicURL || ''
			},
				{ resourceID: result.resourceID.resourceID }
			)
		);
	}

	deleteBead(data, additionalInfo) {
		this.loader = true;
		const headers: any = {};
		const apiData = {
			resourceID: data.resourceID
		};
		this.resourceApiService.deleteResource(apiData, headers).subscribe(
			(response) => {
				this.beadsData.splice(additionalInfo.index, 1);
				this.gfService.openSnackBar('SUCCESS', {
					message: this.locale.translate('resource_deleted'),
					icon: 'check_circle_outline',
					position: 'before'
				});
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => {
				this.loader = false;
			});
	}

	alertPopup(action, data, additionalInfo: any = {}) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			autoFocus: false,
			data: {
				action: 'alert',
				classes: 'warning',
				popup: true,
				icon: 'warning',
				title: this.locale.translate('delete'),
				content: this.locale.translate('delete_bead_text'),
				buttons: [
					{
						type: 'main-action',
						caption: this.locale.translate('yes'),
						key: 'yes'
					},
					{
						type: 'main-action',
						caption: this.locale.translate('no'),
						key: 'no',
						autoFocus: true
					}
				],
				triggerEl: additionalInfo.actionElement
			},
			disableClose: true,
			maxWidth: '560px'
		});
		dialogRef.afterClosed().subscribe((resp) => {
			if (resp) {
				if (resp.key === 'yes') {
					if (action === 'deleteBead') {
						this.deleteBead(data, additionalInfo);
					}
				}
			}
		});
	}

	detail(data) {
		this.loadResource(data);
	}

	loadResource(data) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel', 'advanced-content'],
			autoFocus: false,
			data: {
				action: 'dynamic',
				popup: true,
				component: import('../../resource/resource-detail/resource-detail.component'),
				componentData: [
					// {
					// 	variableName: 'type',
					// 	value: (data.createdBy !== this.currentUser.userID) ? 'assign_to_me' : 'assign_by_me'
					// },
					{
						variableName: 'actualResourceID',
						value: data.resourceID
					},
					{
						variableName: 'actionFrom',
						value: 'knowledgeCard_item'
					}
				]
			},
			disableClose: true,
			maxHeight: '100%',
			maxWidth: '100%',
			height: '100%'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result) {
			}
		});
	}

}
